import { render, staticRenderFns } from "./footballData.vue?vue&type=template&id=a65d5276&scoped=true&"
import script from "./footballData.vue?vue&type=script&lang=js&"
export * from "./footballData.vue?vue&type=script&lang=js&"
import style0 from "./footballData.vue?vue&type=style&index=0&id=a65d5276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65d5276",
  null
  
)

export default component.exports